import { useEffect, useState } from 'react';

// utils
import { useNavOpen, useSearchOpen } from '../mega-menu-provider';
import { useIsDesktop } from 'components/App/SizeProvider';

const CHAT_WIDGET_IDS = [
  'Microsoft_Omnichannel_LCWidget_Chat_Iframe_Window',
  'livechat-basetag',
  'starting_chat',
  'chat-close-button',
];

// This hook toggles the visibility of the chat widget based on the navigation state on viewport S & M

export function useToggleChatWidget() {
  const { isNavOpen } = useNavOpen();
  const { isSearchOpen } = useSearchOpen();
  const isDesktop = useIsDesktop();

  const [isChatClosed] = useState<boolean>(() => {
    if (typeof sessionStorage !== 'undefined') {
      return sessionStorage.getItem('chat_widget_closed') === 'true';
    }
    return false;
  });

  useEffect(() => {
    const show = () => {
      if (isChatClosed) return;

      CHAT_WIDGET_IDS.forEach((id) => {
        const chatElement = document.getElementById(id);
        if (chatElement) {
          chatElement.style.display = 'block';
        }
      });
    };

    const hide = () => {
      CHAT_WIDGET_IDS.forEach((id) => {
        const chatElement = document.getElementById(id);
        if (chatElement) {
          chatElement.style.display = 'none';
        }
      });
    };

    if (isNavOpen || (!isDesktop && isSearchOpen)) {
      hide();
    } else {
      show();
    }
  }, [isNavOpen, isDesktop, isSearchOpen, isChatClosed]);
}
